module.exports = __webpack_public_path__ + "static/img/SyndicateLogo2026.c289e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SyndicateLogo2026.png
// module id = 286
// module chunks = 1